<template>
    <div>

        <modal init_id="UploadModal"
               :init_fields="{}"
               :init_title="trans[locale].Uploader.upload"
               ref="UploadModal"
        >
            <template slot="body" slot-scope="body">
                <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ trans[locale].Uploader.file }}</label>
                    <div class="col-sm-6 ">
                        <button class="btn btn-white"
                                @click="clickUpload">{{ trans[locale].Uploader.choose_file }}
                        </button> ({{ trans[locale].Uploader.max_file_size }})
                        <input type="file" id="uploader" multiple name="uploader" accept="*"
                               @change="getFileName" style="display:none;">
                    </div>
                </div>
                <div class="table-responsive" v-if="file_infos.length > 0">
                    <table class="table table-style2 table-hover table-striped with-edit ">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{ trans[locale].Uploader.file_name }}</th>
                                <th>{{ trans[locale].Uploader.file_size }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="file, index in file_infos">
                                <td>{{ index + 1 }}</td>
                                <td>{{ file.name }}</td>
                                <td>{{ (file.size/1024).toFixed(0) }} KB</td>
                                <td><a href="#" class="btn-table-edit" @click="clearFile(index)"><i class="fas fa-trash-alt"></i></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="file_size_exceed" style="color: red"> ** {{ trans[locale].Uploader.file_size_exceed }} </div>
            </template>
            <template slot="footer" slot-scope="footer">
                <div class="modal-footer">

                    <button type="button" class="btn btn-white" data-dismiss="modal">
                        {{ trans[locale].Uploader.cancel }}
                    </button>
                    <button
                            type="button"
                            class="btn btn-blue"
                            @click="submitFile">
                        {{ trans[locale].Uploader.upload }}
                    </button>
                </div>
            </template>
        </modal>

    </div>
</template>

<script>
    export default {
        data() {
            return Object.assign({
                import: null,
                file_infos: [],
                fileName: '',
                validationResult: [],
                current_step: this.init_step,
                current_step_index: this.init_step_index,
                step_array: this.init_step_array,
                steps_form: this.init_steps_form,
                step_next_url: this.init_step_next_url,
                step_back_url: this.init_step_back_url,
                import_type: 'create',
                success_msg: '',
                success_url: '',
            }, __FORM__, {locale: window.locale});
        },

        props: {
            url: {
                required: true,
                type: String,
            },
            max_file_size : {
                default: 100, // 100MB
            },
        },

        beforeMount() {
            window.eventHub.$on('open-uploader', (element_id) => {
                this.openUploader();
            });
        },

        mounted() {
        },

        computed : {
            total_file_size () {
                let result = 0;
                _.each(this.file_infos, (item, key) => {
                    result += item.size;
                });

                return result; //in byte;
            },

            file_size_exceed () {
                return this.total_file_size > (this.max_file_size * 1024 *1024);
            },
        },

        methods: {
            openUploader() {
                this.$refs.UploadModal.toggle();
            },
            handleFileUpload() {

            },
            clearAllCacheFiles() {
                this.file_infos = [];
                document.getElementById('uploader').value = null;
            },
            submitFile() {
                let self = this;
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');
                let formData = new FormData;
                _.each(this.file_infos, (item, key) => {
                    formData.append('uploads[]', document.getElementById('uploader').files[key]);
                });


                let ajaxSuccessCallbackValidation = (response) => {
                    self.$nextTick(function () {
                        if (_.isUndefined(response.data.success)) {
                            self.validationResult = response.data;
                        }

                        window.eventHub.$emit('list-reload-data');
                        self.$store.commit('setNotification', self.validationResult.msg);

                        this.clearAllCacheFiles();
                        this.openUploader();
                    });
                };
                let ajaxFailCallbackValidation = (error) => {
                    window.eventHub.$emit('list-reload-data');
                    if (error.response.status == '422') {
                        self.$store.commit('setValidationError', error.response.data.errors);
                    } else {
                        self.$store.commit('setError', error.response.data.msg);
                    }
                };

                if (this.file_size_exceed) {
                    console.log('file size exceed');
                } else {
                    this.$root.ajax_post(this.url, formData, ajaxSuccessCallbackValidation, ajaxFailCallbackValidation, true, {headers: {'Content-Type': 'multipart/form-data'}});
                }

            },
            clearFile(index) {
                this.file_infos.splice(index, 1);
            },
            reload() {
                this.$store.commit('clearValidationError');
                this.fileName = '';
                this.getStepInfo(0);
            },
            removeUploadFile() {
                this.fileName = '';
                document.getElementById('import').value = null;
            },
            successAndBack(url) {
                let redirect_url = '';
                if (typeof url != 'undefined') {
                    redirect_url = url;
                } else {
                    redirect_url = this.steps_form[this.step_array[0]]['url'];
                }
                window.location.href = redirect_url;
            },
            clickUpload() {
                document.getElementById('uploader').click();
            },
            getFileName(event) {
                if (event.target.files[0]) {
                    _.each(event.target.files, (item, key) => {
                        this.file_infos.push(item);
                    })
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Uploader/FileUploader.vue